/* ============================================================
   SKINLYNOOR — Scroll reveal + soft interactions
   Add to theme.liquid: {{ 'skinlynoor.js' | asset_url | script_tag }}
   ============================================================ */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.snm-reveal, .snm-fade');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // Re-run when Shopify theme editor injects/reloads a section
  document.addEventListener('shopify:section:load', initReveal);
})();
